import moment from 'moment';

import { IWebinar } from '../common/model/webinar.model';

const initDatesCommon = (webinar: IWebinar): IWebinar => {
  return {
    ...webinar,
    date: webinar.date ? moment(webinar.date) : webinar.date
  };
};

export const initDates = (webinar: IWebinar): IWebinar => {
  return {
    ...initDatesCommon(webinar)
  };
};
